import { Injectable } from "@angular/core";
import { PmsProductDto } from "../interfaces/dto/pms-product.dto";
import { PmsProduct } from "../interfaces/pms-product.interface";

@Injectable({
  providedIn: 'root'
})
export class PmsProductAdapter {
  run(product: PmsProductDto): PmsProduct {
    return {
      ...product
    };
  }
}